import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'ftrDasherize', standalone: true })
export class DasherizePipe implements PipeTransform {
  transform(value: any): any {
    return typeof value === 'string'
      ? value
          .replace(/([a-z\d])([A-Z])/g, '$1-$2') // Camel case to snake case (innerHTML => inner-html)
          .replace(/[ _]/g, '-') // Replaces underscores and spaces with a hyphen
          .toLowerCase()
      : value
  }
}
